import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_CARD_PRESENTED_SCHEMA = Object.freeze({
  SCREEN_NAME: '',
});

const RECORD = generateSchema(TRACKING_CARD_PRESENTED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_CARD_PRESENTED_SCHEMA);

export class CardPresentedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.card_presented;
  }

  get properties() {
    return this.toJS();
  }
}
